import { render } from "./DisclaimerSection.vue?vue&type=template&id=3f537ff4&scoped=true"
import script from "./DisclaimerSection.vue?vue&type=script&lang=js"
export * from "./DisclaimerSection.vue?vue&type=script&lang=js"

import "./DisclaimerSection.vue?vue&type=style&index=0&id=3f537ff4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f537ff4"]])

export default __exports__